<template>
  <header class>
    <NavBarHome style="z-index:20" isLight="false" />
    <Carrusel clas="offsetme" />
  </header>
</template>

<script>
import NavBarHome from "../components/NavBarHome.vue";
import Carrusel from "../components/Carrusel.vue";
export default {
  name: "SiteHeader",
  components: {
    NavBarHome,
    Carrusel
  },
  data() {
    return {};
  },
  methods: {}
};
</script>

<style>
.offsetme {
  margin-top: -150px;
}
@media only screen and (max-width: 991px) {
  .offsetme {
    margin-top: 0px;
  }
}
</style>